module.exports = __webpack_public_path__ + "static/media/plus.bacfb23b.svg";